import Image from "next/image";

const PointOfViewSectionTopContent = () => {
  return (
    <div className="grid grid-cols-12 2xl:w-2/3 rounded-2xl overflow-hidden bg-light">
      <div className="col-span-12 md:col-span-7 flex flex-col items-center justify-center">
        <div className="flex flex-col items-start justify-center p-8 md:p-16 space-y-6">
          <Image
            src="/assets/icons/eye-gradient.png"
            width={48}
            height={48}
            alt="outlook"
          />
          <span className="mobile-h4 md:h5 lg:h4 text-secondary">
            Our point of view
          </span>
          <span className="text-body-lg text-text-color-mid-em">
            At{" "}
            <span className="text-secondary-dark label-lg-bold">
              SimpleWaste
            </span>{" "}
            we’re looking into the industry’s future, making moves and
            incorporating innovations that benefit our clients, our
            stakeholders, and partners.
            <br /> <br />
            We’re looking for like-minded partners who possess excellence in
            business practice with a distinct focus on customer experience.
          </span>
        </div>
      </div>
      <div className="col-span-12 md:col-span-5 flex justify-end">
        <div
          className="min-h-[420px] h-full w-full bg-cover bg-top md:bg-center bg-no-repeat"
          style={{
            backgroundImage:
              "url('/images/partners/point-of-view-01.png')",
          }}
        />
      </div>
    </div>
  );
};
export default PointOfViewSectionTopContent;
